import { useCallback } from 'react';
import { useIframeMessageContext } from '../../IframeMessageContext';
import { registerIframeMessageHook } from './IframeRegistration';
const MESSAGE_TYPE = 'hover-component';
export function useSendHoverComponent() {
    const { postMessage } = useIframeMessageContext();
    const sendHoverComponent = useCallback((component) => {
        postMessage(MESSAGE_TYPE, component);
    }, [postMessage]);
    return { sendHoverComponent };
}
const handleMessage = (context, message) => {
    const { setHoverComponent } = context;
    // console.log('received hover component', message.body);
    setHoverComponent(message.body, { shouldSendIframe: false });
};
registerIframeMessageHook(MESSAGE_TYPE, useSendHoverComponent, handleMessage);
//# sourceMappingURL=useSendHoverComponent.js.map